/**
 * Números de página que se muestran en el pie de una tabla.
 *
 * Siempre incluye la primera y la última página y las vecinas de la actual;
 * los huecos se marcan con '…'. Con pocas páginas las muestra todas.
 *
 *   pageWindow(1, 4)   -> [1, 2, 3, 4]
 *   pageWindow(5, 12)  -> [1, '…', 4, 5, 6, '…', 12]
 *   pageWindow(1, 12)  -> [1, 2, 3, '…', 12]
 *
 * Sin dependencias de Vue: se prueba aparte.
 */
export const ELLIPSIS = '…';

export function pageWindow(page, pageCount, siblings = 1) {
    const total = Math.max(0, Math.floor(pageCount) || 0);
    if (total === 0) return [];
    const current = Math.min(Math.max(1, Math.floor(page) || 1), total);

    // primera + última + actual + vecinas + dos huecos: con menos que esto no hay nada que abreviar
    const slots = siblings * 2 + 5;
    if (total <= slots) return Array.from({ length: total }, (_, i) => i + 1);

    const left = Math.max(current - siblings, 2);
    const right = Math.min(current + siblings, total - 1);
    const showLeftGap = left > 2;
    const showRightGap = right < total - 1;

    // pegado a un extremo se alargan los números del lado corto para que el ancho no salte
    if (!showLeftGap) {
        const head = Array.from({ length: siblings * 2 + 3 }, (_, i) => i + 1);
        return [...head, ELLIPSIS, total];
    }
    if (!showRightGap) {
        const tail = Array.from({ length: siblings * 2 + 3 }, (_, i) => total - (siblings * 2 + 2) + i);
        return [1, ELLIPSIS, ...tail];
    }
    const middle = Array.from({ length: right - left + 1 }, (_, i) => left + i);
    return [1, ELLIPSIS, ...middle, ELLIPSIS, total];
}

/**
 * Página escrita por la persona ("Ir a"): entero acotado a 1..pageCount.
 * Devuelve null si no es un número, para no consultar nada.
 *
 *   clampPage('7', 12)  -> 7
 *   clampPage('999', 12) -> 12
 *   clampPage('abc', 12) -> null
 */
export function clampPage(value, pageCount) {
    const total = Math.floor(pageCount) || 0;
    const n = parseInt(value, 10);
    if (total < 1 || Number.isNaN(n)) return null;
    return Math.min(Math.max(n, 1), total);
}

/** "1–25 de 83": primer y último registro de la página, o ceros si no hay nada. */
export function pageRange(page, itemsPerPage, total) {
    if (!total || total < 1) return { from: 0, to: 0 };
    const from = (page - 1) * itemsPerPage + 1;
    return { from: Math.min(from, total), to: Math.min(page * itemsPerPage, total) };
}
